// 用户个人资料相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 用户个人资料API类
 */
export class ProfileAPI {
  /**
   * 获取用户个人资料
   * @returns {Promise<Object>} 用户资料数据
   */
  static async getUserProfile() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.PROFILE.GET);
      
      console.log('用户资料API响应:', response);
      
      // API拦截器已经处理了响应，直接返回成功格式
      return {
        success: true,
        data: response,
        message: '获取用户资料成功'
      };
    } catch (error) {
      console.error('获取用户资料失败：', error);
      return {
        success: false,
        data: null,
        message: error.apiResponse?.message || error.message || '网络错误'
      };
    }
  }

  /**
   * 更新用户个人资料
   * @param {Object} profileData - 个人资料数据
   * @returns {Promise<Object>} 更新结果
   */
  static async updateUserProfile(profileData) {
    try {
      await apiClient.post(API_ENDPOINTS.PROFILE.UPDATE, profileData);
      
      return {
        success: true,
        message: '更新个人资料成功'
      };
    } catch (error) {
      console.error('更新个人资料失败：', error);
      return {
        success: false,
        message: error.apiResponse?.message || error.message || '网络错误'
      };
    }
  }

  /**
   * 修改密码
   * @param {Object} passwordData - 密码数据
   * @param {string} passwordData.oldPassword - 原密码
   * @param {string} passwordData.newPassword - 新密码
   * @param {string} passwordData.confirmPassword - 确认密码
   * @returns {Promise<Object>} 修改结果
   */
  static async changePassword(passwordData) {
    try {
      await apiClient.post(API_ENDPOINTS.PROFILE.CHANGE_PASSWORD, passwordData);
      
      return {
        success: true,
        message: '修改密码成功'
      };
    } catch (error) {
      console.error('修改密码失败：', error);
      return {
        success: false,
        message: error.apiResponse?.message || error.message || '网络错误'
      };
    }
  }

  /**
   * 上传头像
   * @param {File} file - 头像文件
   * @returns {Promise<Object>} 上传结果
   */
  static async uploadAvatar(file) {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      
      const response = await apiClient.post(API_ENDPOINTS.PROFILE.UPLOAD_AVATAR, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return {
        success: true,
        data: response,
        message: '上传头像成功'
      };
    } catch (error) {
      console.error('上传头像失败：', error);
      return {
        success: false,
        data: null,
        message: error.apiResponse?.message || error.message || '网络错误'
      };
    }
  }
}

export default ProfileAPI;
